import React from 'react'; import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { profile } from '../../modules/customer';
import { withRouter } from 'react-router-dom';
import { ui } from '../../modules';
import { Route, Switch } from 'react-router';
import { contacts, invoices, softwareProducts, hardwareProducts, shippingOrders, workOrders } from '../../modules/customer/profile'
import Details from './components/Details';
import ProfilePageBoxes from './profilePage/ProfilePageBoxes';
import AddHardware from './products/hardwareProducts/addHardwareForm/AddHardware';
import SoftwareProducts from './products/softwareProducts/SoftwareProducts';
import HardwareProducts from './products/hardwareProducts/HardwareProducts';
import ProductCancellation from './products/ProductCancellation';
import ShippingOrders from './shippingOrders/ShippingOrders';
import WorkOrders from './workOrders/WorkOrders';
import Invoices from './invoices/Invoices';
import Contacts from './contacts/Contacts';
import OrderProducts from './order/OrderProducts';
import Products from './products/Products';
import Serials from './products/serials/Serials';
import UpdateCustomerForm from './manage/UpdateCustomerForm';

class Profile extends React.Component {

    loadData = (customerId) => {
        if (!this.props.isLoading && !this.props.isFailed) {
            customerId = customerId || this.props.match.params.id;
            this.props.fetchCustomer(customerId);
            this.props.fetchOTTStatus(customerId);
            this.props.fetchContacts(customerId);
            this.props.fetchInvoiceList(customerId);
            this.props.fetchSoftwareProductsList(customerId);
            this.props.fetchFinancialBalance(customerId);
            this.props.fetchHardwareProductsList(customerId);
            this.props.fetchShippingOrders(customerId);
            this.props.fetchWorkOrders(customerId);
        }
    }

    componentDidMount = () => this.loadData();

    componentWillReceiveProps = (nextProps) => {
        const oldId = this.props.customerId.toString();
        const newId = nextProps.match.params.id;
        if (oldId !== newId) {
            this.loadData(newId)
        }
    }

    render = () => <div className="gemba">
        <Details />
        <Switch >
            <Route path="/customer/:id/software_products" component={SoftwareProducts}/>
            <Route path="/customer/:id/products" component={Products}/>
            {/*<Route path="/customer/:id/invoices" component={Invoices}/>*/}
            <Route path="/customer/:id/contacts" component={Contacts}/>
            <Route path="/customer/:id/shippingorders" component={ShippingOrders}/>
            <Route path="/customer/:id/workorders" component={WorkOrders}/>
            <Route path="/customer/:id/productcancelation" component={ProductCancellation}/>
            <Route path="/customer/:id/hardwareproducts/addhardware" component={AddHardware}/>
            <Route path="/customer/:id/hardwareproducts" component={HardwareProducts}/>
            <Route path="/customer/:id/order" component={OrderProducts}/>
            <Route path="/customer/:id/serials" component={Serials} />
            <Route path="/customer/:id/manage" component={UpdateCustomerForm} />
            <Route path="/customer/:id" component={ProfilePageBoxes} />
        </Switch>
    </div>
}

Profile.propTypes = {
    customerProfile: PropTypes.object.isRequired,
}

const mapStateToProps = createStructuredSelector({
    customerId: profile.selectors.getCustomerID,
    customerProfile: profile.selectors.getCustomerDetails,    
    locationPath: ui.selectors.getLocationPath,
    location: ui.selectors.getLocation,
    isLoading: profile.selectors.isLoading,
    isFailed: profile.selectors.isFailed
});

const mapDispatchToProps = (dispatch, props) => ({
    fetchCustomer: (customerId) => dispatch(profile.actions.fetchCustomer(customerId)),
    fetchOTTStatus: (customerId) => dispatch(profile.actions.fetchOTTStatus(customerId)),
    fetchContacts: (customerId) => dispatch(contacts.actions.fetchContacts(customerId)),
    fetchInvoiceList: (customerId) => dispatch(invoices.actions.fetchInvoiceList(customerId)),
    fetchSoftwareProductsList: (customerId) => dispatch(softwareProducts.actions.fetchSoftwareProductsList(customerId)),
    fetchFinancialBalance: (customerId) => dispatch(invoices.actions.fetchFinancialBalance(customerId)),
    fetchHardwareProductsList: (customerId) => dispatch(hardwareProducts.actions.fetchHardwareProductsList(customerId)),
    fetchShippingOrders: (customerId) => dispatch(shippingOrders.actions.fetchShippingOrders(customerId)),
    fetchWorkOrders: (customerId) => dispatch(workOrders.actions.fetchWorkOrders(customerId))
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Profile));